<template>
  <v-dialog v-model="dialog" max-width="580px">
    <v-card style="height: 150px">
      <v-card-title>
        <span class="pt-2 font-size-medium-large font-weight-medium mx-auto">
          Logout?
        </span>
      </v-card-title>

      <v-card-actions class="position-absolute" style="bottom: 0">
        <v-btn
          class="cvc-button"
          width="270"
          depressed
          @click="hideDialog">
          No
        </v-btn>
        <v-btn
          class="cvc-button"
          width="270"
          depressed
          @click="logOut">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LogoutModal",
  data() {
    return {
      dialog: null
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('logOut').then(() => {
        this.$router.push({ name: 'Login' });
      });
    },
    hideDialog() {
      this.dialog = false;
    },
    showDialog() {
      this.dialog = true;
    }
  }
}
</script>

<style scoped>

</style>